import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  Select,
  SelectChangeEvent,
  MenuItem,
  Divider,
  ListItemIcon,
  Menu,
  Dialog,
  Button,
  IconButton,
  FormControlLabel,
  Switch,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useLocation, useNavigate } from "react-router-dom";
import { ApiGetClientEntityId } from "../../apiService/Core/Apicall";
import { CancelOutlined, Logout, PersonAdd, Settings } from "@mui/icons-material";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setEntity } from "../../global/config/Reducer/clientEntitySlice";
import { json } from "stream/consumers";
import { RootState } from "../../global/config/Reducer";
import { setallclientEntityIds, setisWholeGroup } from "../../global/config/Reducer/WholeGroupSlice";
import storage from "../../utils/storage";

function Header() {
  const location = useLocation();
  const userData = JSON.parse(storage.getItem("userData") || "{}");
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [currentStep, setCurrentStep] = useState<number>(
    parseInt(storage.getItem("currentStep") ?? "1", 10)
  );
  const [clientEntities, setClientEntities] = React.useState<any[]>([]);
  const [selectedEntity, setselectedEntity] = React.useState<any>();

  // const ActiveTask = storage.getItem('ActiveTask')
  const [ActiveTask, setActiveTask] = useState<any>(() => {
    const saved = storage.getItem("ActiveTask") || "";
    return saved.charAt(0).toUpperCase() + saved.slice(1);
  });
  ;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openlogout, setopenlogout] = React.useState<boolean>(false);
  const clientId = storage.getItem('clientId')
  const { isWholeGroup, clientEntityIds } = useSelector((state: RootState) => state.wholegroup)

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };




  React.useEffect(() => {
    const timer = setTimeout(() => {
      setselectedEntity(storage.getItem('clientEntityId'));
    }, 500);

    return () => clearTimeout(timer);
  }, [clientEntities]);
  useEffect(() => {
    const interval = setInterval(() => {
      const newValue = storage.getItem("ActiveTask");
      const finalnewvalue = newValue && newValue.charAt(0).toUpperCase() + newValue.slice(1);
      if (newValue !== ActiveTask) {
        setActiveTask(finalnewvalue);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [ActiveTask]);

  const currentStepRef = useRef(currentStep);
  useEffect(() => {
    currentStepRef.current = currentStep; // Always keep the latest value
  }, [currentStep]);

  // Effect to update currentStep when it changes in storage
  useEffect(() => {
    const handleStorageChange = () => {
      setCurrentStep(parseInt(storage.getItem("currentStep") ?? "1", 10));
    };

    window.addEventListener("storage", handleStorageChange);

    const interval = setInterval(() => {
      const storedStep = storage.getItem("currentStep");

      if (storedStep === null) {
        setCurrentStep(0);
      } else {
        const parsedStep = parseInt(storedStep, 10);
        setCurrentStep((prevStep) =>
          prevStep !== parsedStep ? parsedStep : prevStep
        );
      }
    }, 500);

    // **Detect Tab Visibility Change**
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        setTimeout(() => {
          const storedStep = storage.getItem("currentStep");
          setCurrentStep(storedStep ? parseInt(storedStep, 10) : 0);
        }, 1000); // Delay ensures React updates the state properly
      } else {
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      clearInterval(interval);
    };
  }, []);

  // **Clear currentStep when navigating away from CreateOrEditScoreCard**
  useEffect(() => {
    // Check if the current path contains "createOrEditScoreCard"
    const isOnCreateOrEditScoreCard = location.pathname.includes(
      "createOrEditScoreCard"
    );

    if (!isOnCreateOrEditScoreCard) {
      storage.removeItem("currentStep");
      setCurrentStep(0); // Reset state as well
    }
  }, [location.pathname]); // Runs every time the route changes

  // useEffect(() => {
  //   const getclientEntity = async () => {
  //     if (storage.getItem('userRole') === 'clientadmin' && (clientId || clientId !== null)) {
  //       const response2 = clientId && await ApiGetClientEntityId(clientId)
  //       setClientEntities(response2?.data[0]?.sort((a: any, b: any) => Number(b.clientEntityId) - Number(a.clientEntityId)))

  //       const allClientEntityIds = response2.data[0]
  //         .sort((a: any, b: any) => Number(b.clientEntityId) - Number(a.clientEntityId))
  //         .map((item: any) => item.clientEntityId)
  //         .join(",");
  //       dispatch(setallclientEntityIds(allClientEntityIds))

  //       if (!storage.getItem("clientEntityId")) {
  //         clientId && storage.setItem('clientEntityId', response2.data[0][0].clientEntityId)
  //         clientId && storage.setItem('ratingJson', response2.data[0][0].ratingJson)
  //         clientId && storage.setItem('clientEntityName', response2.data[0][0].entityName)
  //         storage.getItem('userRole') === 'clientadmin' && storage.setItem('dwc', response2.data[0][0]?.isAllowDownloadWithoutComments);
  //         storage.getItem('userRole') === 'clientadmin' && storage.setItem('INF', response2.data[0][0]?.hideFixIt);
  //         storage.getItem('userRole') === 'clientadmin' && storage.setItem('ISC', response2.data[0][0]?.hideSiteComparison);

  //       }
  //     }


  //   }
  //   getclientEntity()
  // }, [])
  useEffect(() => {
    const getclientEntity = async () => {
      const userData: any = JSON.parse(storage.getItem("userOtherData") || "{}");
      if (storage.getItem('userRole') !== 'clientadmin' && userData) {
        // const response2 = clientId && await ApiGetClientEntityId(clientId)
        // console.log("venues", userData?.venues)
        let uniqueClients: any = []
        // if (storage.getItem('userRole') === 'venueadmin') {
        //   uniqueClients =  Object?.values(
        //     userData?.venues?.reduce((acc: any, { clientEntityId, clientEntityName }: any) => {
        //       acc[clientEntityId] = { clientEntityId, clientEntityName };
        //       return acc;
        //     }, {})
        //   );
        // }
        if (storage.getItem('userRole') === 'venueadmin') {
          const reducedData =
            userData?.venues?.reduce(
              (acc: any, { clientEntityId, clientEntityName }: any) => {
                acc[clientEntityId] = { clientEntityId, clientEntityName };
                return acc;
              },
              {}
            ) || {};   // 👈 important fallback

          uniqueClients = Object.values(reducedData);
        }
        else if (storage.getItem('userRole') === 'areaManager') {
          uniqueClients = userData?.areas
          if (!storage.getItem("areaId")) {
            storage.setItem('areaId', uniqueClients[0].areaId)
            storage.setItem('areaName', uniqueClients[0].areaName)
          }
        }
        setClientEntities(uniqueClients)
        if (!storage.getItem("clientEntityId")) {
          storage.setItem('clientEntityId', uniqueClients[0]?.clientEntityId)
          storage.setItem('clientEntityName', uniqueClients[0]?.clientEntityName)
          storage.setItem('cssNPS', userData?.canClientSeeNPSScore)
        }
      }


    }
    getclientEntity()
  }, [])

  useEffect(() => {
    const getclientEntity = async () => {
      try {
        if (
          storage.getItem('userRole') !== 'clientadmin' ||
          !clientId
        ) {
          return;
        }


        const response2 = await ApiGetClientEntityId(clientId);

        const entities = response2?.data?.[0] || [];

        if (!entities.length) {
          return;
        }

        // const sortedEntities = entities.sort(
        //   (a: any, b: any) =>
        //     Number(a.clientEntityId) -
        //     Number(b.clientEntityId)
        // );
        const sortedEntities = entities.sort((a: any, b: any) => {
          if (a.entityCode === "SON") {
            return Number(a.clientEntityId) - Number(b.clientEntityId); // Ascending
          }
          return Number(b.clientEntityId) - Number(a.clientEntityId); // Descending
        });


        setClientEntities(sortedEntities);

        const allClientEntityIds = sortedEntities
          .map((item: any) => item.clientEntityId)
          .join(",");

        dispatch(setallclientEntityIds(allClientEntityIds));

        const firstEntity = sortedEntities[0];

        if (
          !storage.getItem("clientEntityId") &&
          firstEntity
        ) {
          storage.setItem(
            'clientEntityId',
            firstEntity.clientEntityId
          );

          storage.setItem(
            'ratingJson',
            firstEntity.ratingJson
          );

          storage.setItem(
            'clientEntityName',
            firstEntity.entityName
          );

          storage.getItem('userRole') === 'clientadmin' &&
            storage.setItem(
              'dwc',
              firstEntity?.isAllowDownloadWithoutComments
            );

          storage.getItem('userRole') === 'clientadmin' &&
            storage.setItem(
              'INF',
              firstEntity?.hideFixIt
            );

          storage.getItem('userRole') === 'clientadmin' &&
            storage.setItem(
              'ISC',
              firstEntity?.hideSiteComparison
            );
         storage.getItem('userRole') === 'clientadmin' && storage.setItem('cssNPS', firstEntity?.canClientSeeNPSScore)

        }
      } catch (error) {
        console.log(error);
      }
    };

    getclientEntity();
  }, [clientId]);

  useEffect(() => {
    dispatch(setEntity(selectedEntity))
  }, [selectedEntity, clientEntities])   
  return (
    <Box className="h-100">
      <Box
        height="64px"
        marginLeft='auto'
        width={{ xs: '90%', md: '100%' }}
        className="bg-white px-4 d-flex align-items-center  justify-content-between"
      >
        {/* Left-aligned text */}
        <Typography variant="h5" fontWeight={600}>
          {ActiveTask == 'CategoryReport' ? 'Category Comparision Report' :
           (ActiveTask == 'ScoreCard' || ActiveTask == 'scoreCard') ? 'Results' :
           (ActiveTask == 'reports' || ActiveTask == 'Reports') ? 'Insights' :
            ActiveTask?.charAt(0)?.toUpperCase() + ActiveTask?.slice(1)?.replace(/([A-Z])/g, ' $1').trim()
          }
        </Typography>


        {/* Right-aligned user info */}
        <Box width={'70%'} className="d-flex gap-4  justify-content-end align-items-center" sx={{ cursor: 'pointer' }} >
          {clientEntities?.length > 0 && (
            <>
              <Select
                className='text-end d-none d-md-flex'
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={selectedEntity}
                key={selectedEntity}
                sx={{
                  // width: "100% !important" ,
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none !important'
                  }
                }}
                onChange={(event: SelectChangeEvent<string | null>, child) => {
                  if (event.target.value !== null) {
                    setselectedEntity(event.target.value)
                    storage.setItem('clientEntityId', event.target.value);
                    const matchedItem = clientEntities.find(item => item.clientEntityId === event.target.value);
                    if (matchedItem) {
                      storage.setItem('clientEntityName', matchedItem?.clientEntityName ?? matchedItem.entityName);
                      storage.setItem('cssNPS', matchedItem?.canClientSeeNPSScore)
                      storage.getItem('userRole') === 'clientadmin' && storage.setItem('dwc', matchedItem?.isAllowDownloadWithoutComments);
                      matchedItem.ratingJson !== undefined && storage.setItem('ratingJson', matchedItem.ratingJson);
                      matchedItem?.areaId && storage.setItem('areaId', matchedItem.areaId);
                      matchedItem?.areaName && storage.setItem('areaName', matchedItem.areaName);
                    }
                  }
                }} >
                {
                  clientEntities && clientEntities.map((item: any, index) => (
                    <MenuItem value={item.clientEntityId} key={index}>{item?.clientEntityName ?? item.entityName}</MenuItem>
                  ))
                }

              </Select>
            </>
          )}
          {/* <Typography>Abc Group</Typography> */}
          <Box className='d-flex align-items-center gap-3'>
            <Avatar
              src={userData.profilePicUrl}
              onClick={handleClick}
              sx={{ height: "32px", border: '1px solid grey', width: "32px" }}
            />

            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              slotProps={{
                paper: {
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    '&::before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                },
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              <MenuItem onClick={handleClose}>
                <Avatar />  {userData.displayName}
              </MenuItem>
              <MenuItem onClick={handleClose}>
                <Select
                  className='month-select text-end'
                  sx={{ width: "100% !important" }}
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={selectedEntity}
                  onChange={(event: SelectChangeEvent<string | null>, child) => {
                    if (event.target.value !== null) {
                      setselectedEntity(event.target.value)
                      storage.setItem('clientEntityId', event.target.value);
                      const matchedItem = clientEntities.find(item => item.clientEntityId === event.target.value);
                      if (matchedItem) {
                        storage.setItem('clientEntityName', matchedItem?.clientEntityName ?? matchedItem.entityName);
                      }
                    }
                  }} >
                  {
                    clientEntities && clientEntities.map((item: any, index) => (
                      <MenuItem value={item.clientEntityId} key={index}>{item?.clientEntityName ?? item.entityName}</MenuItem>
                    ))
                  }

                </Select>
              </MenuItem>
              <MenuItem onClick={() => { setopenlogout(true); handleClose() }}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                Logout
              </MenuItem>

            </Menu>

            <Typography display={{ xs: 'none', md: "block" }} whiteSpace='nowrap' variant="subtitle1" >
              {userData.displayName}
            </Typography>
            <KeyboardArrowDownIcon sx={{ display: { xs: 'none' } }} className="text-dark" />
          </Box>
        </Box>
      </Box>

      <Dialog onClose={() => { setopenlogout(false) }} open={openlogout}>
        <Box className='p-2 px-3' width='250px' height='120px'>
          <Box className='d-flex align-items-center justify-content-between'>
            <Typography className="mb-2" variant="h6">Are You Sure ? </Typography>
            <IconButton onClick={() => { setopenlogout(false) }}><CancelOutlined /></IconButton>
          </Box>
          <Box className='d-flex my-3 align-items-center gap-3'>
            <Button className='button-primary' onClick={() => { storage.clear(); localStorage.clear(); navigate('/') }}> Log Out</Button>
            <Button className='btn btn-secondary' variant="contained" onClick={() => { setopenlogout(false) }}>Cancel</Button>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
}

export default Header;
